import anime from "animejs";

export default class Mobile {
  constructor() {
    this._hb = document.querySelector(".jsMobileOpen");
    if (this._hb) this.init();

    this._navWrap = document.querySelector(".jsMobileWrap");
    this._navGlass = document.querySelector(".jsMobileGlass");
    this._navLogo = document.querySelector(".jsMobileLogo");
    this._navMenu = document.querySelectorAll(".jsMobileMenu");

    this._main = document.querySelector(".jsMain");

    // helper
    this._complete = false;
  }

  openMenu() {
    this._complete = false;

    // switch hb mode
    this._navWrap.classList.add("active");

    document.body.style.overflow = "hidden";

    // display nav
    let timelineIn = anime.timeline();

    timelineIn
      .add({
        targets: this._main,
        filter: "blur(6px)",
        // scale: 1.05,
        duration: 150,
        easing: "linear"
      })
      .add({
        targets: this._navGlass,
        opacity: 1,
        duration: 400,
        easing: "easeOutExpo"
      })
      // .add({
      //   targets: this._navLogo,
      //   translateY: [-50, 0],
      //   opacity: 1,
      //   duration: 750,
      //   easing: "easeOutExpo"
      // })
      .add({
        targets: this._navMenu,
        opacity: 1,
        easing: "easeOutExpo",
        duration: 1500,
        offset: 650,
        complete: anim => {
          this._complete = anim.completed;
        }
      });

    this._hb.classList.toggle("active");
  }

  closeMenu() {
    document.body.style.overflow = "inherit";
    this._navWrap.classList.remove("active");

    // display nav
    let timelineOut = anime.timeline();

    timelineOut
      .add({
        targets: this._main,
        filter: "blur(0px)",
        // scale: 1,
        duration: 10
      })
      .add({
        targets: this._navGlass,
        opacity: 0,
        duration: 10
      })
      .add({
        targets: this._navMenu,
        opacity: 0,
        duration: 10
      });
    // .add({
    //   targets: this._navLogo,
    //   opacity: 0,
    //   duration: 10
    // });

    this._hb.classList.toggle("active");
  }

  init() {
    this._hb.addEventListener("click", () => {
      if (this._hb.classList.contains("active")) {
        if (this._complete) this.closeMenu();
      } else {
        this.openMenu();
      }
    });
  }
}
